import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import BgImgOne from "../../images/home-update/nextgen/nextgen-banner-3.webp";
import BgImgTwo from "../../images/home-update/nextgen/nextgen-banner-1.webp";
import BgImgThree from "../../images/home-update/nextgen/nextgen-banner-2.webp";
// Import Swiper React components
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination, Autoplay } from "swiper/modules";
import "swiper/css";
import "swiper/css/pagination";
import { Link } from "gatsby";

function NextGen({ handleShow }) {
  const [swiper, setSwiper] = React.useState();
  const prevRef = React.useRef();
  const nextRef = React.useRef();

  React.useEffect(() => {
    if (swiper) {
      console.log("Swiper instance:", swiper);
      swiper.params.navigation.prevEl = prevRef.current;
      swiper.params.navigation.nextEl = nextRef.current;
      swiper.navigation.init();
      swiper.navigation.update();
    }
  }, [swiper]);
  return (
    <section className="tekrevol__nextgen overflow-x-hidden p-100">
      <Container>
        <Row>
          <Col
            xs={12}
            md={12}
            lg={12}
            xl={12}
            xxl={12}
            className="mt-auto mb-auto"
          >
            <div className="example example-bottom" data-text="AI Services">
              <h2>Next-Gen Solutions Through Artificial Intelligence</h2>
            </div>
          </Col>

          <Col
            xs={12}
            md={12}
            lg={12}
            xl={12}
            xxl={12}
            className="mt-auto mb-auto"
          >
            <Swiper
              modules={[Navigation, Pagination, Autoplay]}
              spaceBetween={30}
              slidesPerView={1}
              // navigation={{
              // prevEl: prevRef?.current,
              // nextEl: nextRef?.current,
              // }}
              autoplay={{
                delay: 3000,
                disableOnInteraction: false,
                pauseOnMouseEnter: true,
              }}
              pagination={{ clickable: true }}
              onSwiper={setSwiper}
              onSlideChange={() => console.log("slide change")}
              className="carosal_nextgen"
            >
              <SwiperSlide>
                <div
                  className="nextgen-item"
                  style={{ backgroundImage: `url(${BgImgOne})` }}
                >
                  <div className="nextgen-content">
                    <h3 className="title">
                      Transform Data
                      <br className="d-lg-block d-none" /> Strategy for{" "}
                      <span>Gen AI</span>
                    </h3>
                    <p>
                      Experience seamless AI deployment and management with our
                      AI Center of Excellence. From rapid product iterations to
                      NLP-driven insights, we enhance your AI capabilities and
                      optimize ROI.
                    </p>
                    <Link
                      to="/ai-development-company"
                      className="btn-pri"
                      aria-label="Transform Data Strategy for Gen AI"
                    >
                      Get Started Today!
                    </Link>
                    {/* <span className="btn-pri" onClick={handleShow}>
                      Get Started Today!
                    </span> */}
                  </div>
                </div>
              </SwiperSlide>
              <SwiperSlide>
                <div
                  className="nextgen-item"
                  style={{ backgroundImage: `url(${BgImgTwo})` }}
                >
                  <div className="nextgen-content">
                    <h3 className="title">
                      AI Excellence at Your
                      <br className="d-lg-block d-none" />{" "}
                      <span>Fingertips</span>
                    </h3>
                    <p>
                      Achieve efficient AI integration with our tailored
                      solutions. We support AI practice management and
                      scalability, helping you maintain a competitive advantage
                      and streamline operations.
                    </p>
                    <Link
                      to="/ai-development-company"
                      className="btn-pri"
                      aria-label="Transform Data Strategy for Gen AI"
                    >
                      Get Started Today!
                    </Link>
                    {/* <span className="btn-pri" onClick={handleShow}>
                      Get Started Today!
                    </span> */}
                  </div>
                </div>
              </SwiperSlide>
              <SwiperSlide>
                <div
                  className="nextgen-item"
                  style={{ backgroundImage: `url(${BgImgThree})` }}
                >
                  <div className="nextgen-content">
                    <h3 className="title">
                      Maximize AI <br className="d-lg-block d-none" />
                      Integration <span>Efficiency</span>
                    </h3>
                    <p>
                      Augment the power of Gen AI with our comprehensive data
                      strategy solutions. We specialize in automated data
                      segmentation and integration, ensuring top-tier data
                      quality with ML and MLOps.
                    </p>
                    <Link
                      to="/ai-development-company"
                      className="btn-pri"
                      aria-label="Transform Data Strategy for Gen AI"
                    >
                      Get Started Today!
                    </Link>
                    {/* <span className="btn-pri" onClick={handleShow}>
                      Get Started Today!
                    </span> */}
                  </div>
                </div>
              </SwiperSlide>
            </Swiper>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default NextGen;
